import { SidenavService } from './../services/sidenav.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { OverviewData } from '../overview/overview.component';
import { AppStateProvider } from '../services/app-state.provider';
import { CommonService } from '../services/common.service';
import { OverviewService } from '../services/overview.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';

@Component({
  standalone: false,
  selector: 'app-overview-module',
  templateUrl: './overview-module.component.html',
  styleUrls: ['./overview-module.component.scss'],
})
export class OverviewModuleComponent implements OnInit {
  meetingNav;
  hover: boolean = false;
  isDisplay: any;
  index: any;
  changeText: boolean;
  changeEmployeeText: boolean;
  changeEmployeeCheckedText: boolean;
  changeDayPassText: boolean;
  changeCompliCredit: boolean;
  changeClaCredit: boolean;
  changeMeetingRoomsText: boolean;
  changeParkingText: boolean;
  changeBulkInviteReq: boolean;
  changeCompanyText: boolean;
  overviewData = new OverviewData();
  data: any;
  parkId = localStorage.getItem('parkId');
  manageServiceMenus: any[];
  usersMenus: any[];
  surveyMenus: any[];
  foodCourtMenus: any[];
  tokens: any;
  dataSurvey: any;

  constructor(
    private sideNavService: SidenavService,
    // private adalService: MsAdalAngular6Service,
    private commonService: CommonService,
    private route: Router,
    private appStateSrv: AppStateProvider,
    private overviewSrv: OverviewService,
    private router: Router,
    private modalService: NgbModal,
    private authService: MsalService, // newly added
  ) {
    this.getAdminForCheckinToken();
    if (localStorage.getItem('claAdminId')) {
      this.commonService.getParkByCLAId();
    }
  }

  ngOnInit(): void {
    const route = this.sideNavService.routingChunks({ name: 'Overview' });
    this.appStateSrv.setSideNavState(route);
    this.getOverviewData();

    this.usersMenus = [
      {
        title: 'Coustomer Service Users',
        categories: [
          {
            title: 'Create',
            icon: './assets/images/icons/create_new_smes.svg',
            link: '/create-new-customer',
          },
          {
            title: 'View List',
            icon: './assets/images/icons/view_list_of_smes.svg',
            link: '/list-customer-service-user',
          },
          {
            title: 'Add Groups',
            icon: './assets/images/icons/add_sme_groups.svg',
            link: '/customer-service-group',
          },
          {
            title: 'View Groups',
            icon: './assets/images/icons/view_sme_groups.svg',
            link: '/list-service-group',
          },
        ],
      },
    ];

    this.getUserPermissionMenuSurvey();
    this.getUserPermissionMenuFoodCourt();
    this.getUserPermissionMenuVegitation();
  }

  getAdminForCheckinToken() {
    this.getParkbyClaId();
    // console.log("in overview page");
    // let emailAddress = localStorage.getItem('loginemailaddress');
    // this.commonService.getAdminTokenInOverviewPage(emailAddress).subscribe(r => {
    //   this.tokens = JSON.parse(localStorage.getItem('Tokens'));
    //   this.commonService.setTokenAfterSelectionForOverViewPage(this.tokens[0]);
    //   this.getParkbyClaId();
    //   // location.reload();
    // });
  }

  getAdmin() {
    // this.commonService
    //   .getAdminToken(this.adalService.LoggedInUserEmail)
    //   .subscribe((r) => {
    //     if (r.isValid == false) {
    //       this.route.navigateByUrl('');
    //     }
    //   });

    this.commonService
      .getAdminToken(localStorage.getItem('userEmail'))
      .subscribe((r) => {
        if (r.isValid == false) {
          this.logoutFromCla();
          // this.route.navigateByUrl('');
        }
      });
  }

  getParkbyClaId() {
    this.commonService.getParkByCLAId().subscribe((res) => {
      console.log('is valid check', res.isValid);
      if (res.isValid) {
        if (localStorage.getItem('parkId')) {
          // if (res.list[0].locationId) {
          //   localStorage.setItem('locationId', res.list[0].locationId);
          // } else {
          //   localStorage.setItem('locationId', '1');
          // }
        } else {
          localStorage.setItem('parkId', res.list[0].parkId);
        }
        if (
          localStorage.getItem('locationId') == '' ||
          localStorage.getItem('locationId') == 'null' ||
          localStorage.getItem('locationId') == null
        ) {
          localStorage.setItem('locationId', res.list[0].locationId);
        }
        // console.log('parkId', res.list[0].parkId)
        // localStorage.setItem('parkId', res.list[0].parkId);
        localStorage.setItem('parkDropDownDetails', JSON.stringify(res.list));
        this.getOverviewData();
      }
    });
  }

  getOverviewData() {
    this.parkId = localStorage.getItem('parkId');
    if (this.parkId == null) {
      return;
    }
    const data = {
      ParkId: this.parkId,
    };
    this.overviewSrv.getParkiteOverviewDetail(data).subscribe((res) => {
      console.log(res);
      this.data = res;
    });
    this.overviewSrv
      .getOverViewDataForSurveyOnly(this.parkId)
      .subscribe((resp) => {
        console.log(resp);
        this.dataSurvey = resp;
      });
  }

  routeToMeetingReport() {
    const fromDate =
      new Date().getMonth() +
      1 +
      '/' +
      new Date().getDate() +
      '/' +
      new Date().getFullYear();
    const toDate =
      new Date().getMonth() +
      1 +
      '/' +
      new Date().getDate() +
      '/' +
      new Date().getFullYear();
    const queryParams = {
      type: 4,
      fromDate: fromDate,
      toDate: toDate,
      select: 'All',
    };
    console.log('queryParams', queryParams);

    localStorage.setItem('reportQuery', JSON.stringify(queryParams));
    this.router.navigate(['/parkite-reports']);
  }
  changeImage() {
    this.hover = !this.hover;
  }
  mouseEnter(data: any, index) {
    this.hover = data;
    this.index = index;
  }

  mouseLeave(data: any, index) {
    this.hover = data;
    this.index = index;
  }

  routeToReports() {
    localStorage.setItem('temp', '3');
    this.router.navigate(['/parkite-reports']);

    // localStorage.setItem('temp', '11');
    // this.router.navigate(['/reports']);
  }

  redirectToAccess() {
    localStorage.setItem('expandNav', 'true');
    // localStorage.setItem('expandNavLand', 'true');
    const route = this.sideNavService.routingChunks({
      name: 'VMS Approval',
      subNav: '1',
      subNavLink: '/whitelist',
    });
    this.appStateSrv.setSideNavState(route);
    this.router.navigate(['/whitelist']);
  }

  manageServices(content: any): void {
    this.modalService.open(content, { size: 'md' });
  }

  usersModal(content: any): void {
    this.modalService.open(content, { size: 'xl' });
  }

  surveyModal(content: any): void {
    this.modalService.open(content, { size: 'md' });
  }

  foodCourtModal(content: any): void {
    this.modalService.open(content, { size: 'md' });
  }

  goToPage(link: string): void {
    this.modalService.dismissAll();
    this.router.navigate([link]);
  }

  logoutFromCla() {
    setTimeout(() => {
      this.logoutFromAd();
    }, 10000);
  }

  logoutFromAd(popup?: boolean) {
    // if (popup) {
    //   this.authService.logoutPopup({
    //     mainWindowRedirectUri: environment.domain + '/' // "http://localhost:4200/"
    //   });
    // } else {
    //   this.authService.logoutRedirect();
    // }
    window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURI(environment.domain)}`
  }

  getUserPermissionMenuSurvey() {

    this.surveyMenus = [
      {
        title: 'Surveys/Polls',
        key: 'Survey & Polls',
        sub: [
          {
            title: 'Create Survey/Poll',
            icon: './assets/images/icons/add_new_plant_trees.svg',
            link: '/create-survey',
            subkey: 'Create',
          },
          {
            title: 'View Surveys/Polls',
            icon: './assets/images/icons/view_list_of_plant_trees.svg',
            link: '/list-survey',
            subkey: 'View',
          },
        ],
      },
      // {
      //   title: 'Coupons',
      //   categories: [
      //     {
      //       title: 'View Coupons',
      //       icon: './assets/images/icons/view_list_of_plant_trees.svg',
      //       link: '/list-coupon',
      //     },
      //   ],
      // },
    ];

    const permissionData = JSON.parse(localStorage.getItem('claAdminPermissions'));
    if (permissionData.modulePermission.length > 0) {
      // Creating a parent-child array
      const result = permissionData.modulePermission.reduce((acc, item) => {
        const [parent, child] = item.split(":");
        const existingParent = acc.find(entry => entry.category === parent);

        if (existingParent) {
          existingParent.actions.push(child);
        } else {
          acc.push({ category: parent, actions: [child] });
        }
        return acc;
      }, []);

      // Filter masterArray based on matching keys with childArray's category
      this.surveyMenus = this.surveyMenus.filter(masterItem => {
        // Check if the key of masterItem exists in childArray
        return result.some(childItem => childItem.category === masterItem.key);
      });

      // assign the new menu to the master menu with child
      this.surveyMenus = this.filterMasterArrayWithSub(this.surveyMenus, result);
    }
  }

  getUserPermissionMenuFoodCourt() {

    this.foodCourtMenus = [
      {
        title: 'Food Court Management',
        key: 'Food Court',
        sub: [
          {
            title: 'View Food Courts',
            icon: './assets/images/icons/view_list_of_plant_trees.svg',
            link: '/list-food-court',
            subkey: 'View',
          },
          {
            title: 'Add Food Court',
            icon: './assets/images/icons/add_new_plant_trees.svg',
            link: '/create-food-court',
            subkey: 'Create',
          },
          {
            title: 'Add Vendor Details',
            icon: './assets/images/icons/add_new_plant_trees.svg',
            link: '/create-food-vendor',
            subkey: 'CreateVendor',
          },
        ],
      },
    ];

    const permissionData = JSON.parse(localStorage.getItem('claAdminPermissions'));
    if (permissionData.modulePermission.length > 0) {
      // Creating a parent-child array
      const result = permissionData.modulePermission.reduce((acc, item) => {
        const [parent, child] = item.split(":");
        const existingParent = acc.find(entry => entry.category === parent);

        if (existingParent) {
          existingParent.actions.push(child);
        } else {
          acc.push({ category: parent, actions: [child] });
        }
        return acc;
      }, []);

      // Filter masterArray based on matching keys with childArray's category
      this.foodCourtMenus = this.foodCourtMenus.filter(masterItem => {
        // Check if the key of masterItem exists in childArray
        return result.some(childItem => childItem.category === masterItem.key);
      });

      // assign the new menu to the master menu with child
      this.foodCourtMenus = this.filterMasterArrayWithSub(this.foodCourtMenus, result);
    }
  }

  getUserPermissionMenuVegitation() {

    this.manageServiceMenus = [
      {
        title: 'Landscaping Vegetation',
        key: 'Managed Services',
        sub: [
          {
            title: 'Add New Plant/Trees',
            icon: './assets/images/icons/add_new_plant_trees.svg',
            link: '/landscaping-and-vegetation',
            subkey: 'Create',
          },
          {
            title: 'View List of Plants/Trees',
            icon: './assets/images/icons/view_list_of_plant_trees.svg',
            link: '/list-of-plants-trees',
            subkey: 'View',
          },
        ],
      },
    ];

    const permissionData = JSON.parse(localStorage.getItem('claAdminPermissions'));
    if (permissionData.modulePermission.length > 0) {
      // Creating a parent-child array
      const result = permissionData.modulePermission.reduce((acc, item) => {
        const [parent, child] = item.split(":");
        const existingParent = acc.find(entry => entry.category === parent);

        if (existingParent) {
          existingParent.actions.push(child);
        } else {
          acc.push({ category: parent, actions: [child] });
        }
        return acc;
      }, []);

      // Filter masterArray based on matching keys with childArray's category
      this.manageServiceMenus = this.manageServiceMenus.filter(masterItem => {
        // Check if the key of masterItem exists in childArray
        return result.some(childItem => childItem.category === masterItem.key);
      });

      // assign the new menu to the master menu with child
      this.manageServiceMenus = this.filterMasterArrayWithSub(this.manageServiceMenus, result);
    }
  }

  // Filter the masterArray based on childArray
  filterMasterArrayWithSub(masterArray, childArray) {
    return masterArray.map((item: { key: any; sub: any[]; }) => {
      const matchingChild = childArray.find((child: { category: any; }) => child.category === item.key);
      if (matchingChild) {
        const filteredSub = item.sub.filter(subItem => matchingChild.actions.includes(subItem.subkey)); // this.filterSubByActions(item.sub, matchingChild.actions); 
        return { ...item, sub: filteredSub };
      } else {
        return item;
      }
    });
  }
}
